// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconShipping = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'none', ...props },
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.722.054a.75.75 0 01.556 0l11.25 4.5a.75.75 0 010 1.392l-11.25 4.5a.75.75 0 01-.556 0l-11.25-4.5a.75.75 0 010-1.392l11.25-4.5zM2.769 5.25L12 8.942l9.23-3.692L12 1.558 2.77 5.25z"
      fill="currentColor"
    />,
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.029 4.554l11.25 4.5a.75.75 0 01.471.696v13.5a.75.75 0 01-1.028.696l-11.25-4.5A.75.75 0 010 18.75V5.25h.75l.279-.696zM1.5 6.358v11.884l9.75 3.9V10.258l-9.75-3.9z"
      fill="currentColor"
    />,
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.75 10.258v11.884l9.75-3.9V6.358l-9.75 3.9zm10.5-5.008l-.279-.696-11.25 4.5a.75.75 0 00-.471.696v13.5a.75.75 0 001.028.696l11.25-4.5A.75.75 0 0024 18.75V5.25h-.75z"
      fill="currentColor"
    />,
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.24 2.496a.75.75 0 01.976-.417l11.25 4.5a.75.75 0 01-.558 1.392l-11.25-4.5a.75.75 0 01-.417-.975zM21.321 16.221a.75.75 0 01-.418.975l-1.874.75a.75.75 0 01-.558-1.392l1.875-.75a.75.75 0 01.975.417z"
      fill="#212936"
    />
  );
export default SvgIconShipping;
